module.exports = __webpack_public_path__ + "img/mstile-310x150.c23c8865.png";